<template>
  <!-- meterStatistics 抄表统计-->
  <div class="mydayreport" style="padding: 8px;">
    <div class="ul_box">
      <div class="ul_tit">统计数值</div>
      <div class="ul">
        <div class="li">
          <span class="tt">本月预付费金额</span>
          <span class="num">¥59562.00</span>
          <div class="text">已使用:￥40000.00 剩余:￥19562.00</div>
          <img src="@/assets/imgs/c1.png">
        </div>
        <div class="li">
          <span class="tt">设备总数</span>
          <span class="num">100</span>
          <div class="text">电表:60个 水表: 40个</div>
          <img src="@/assets/imgs/c2.png">
        </div>
        <div class="li">
          <span class="tt">本月欠费金额</span>
          <span class="num">¥48000.00</span>
          <div class="text">欠费表数:20/100</div>
          <img src="@/assets/imgs/c3.png">
        </div>
        <div class="li">
          <span class="tt">电表欠费金额</span>
          <span class="num">¥38000.00</span>
          <div class="text">欠费表数: 12/60</div>
          <img src="@/assets/imgs/c4.png">
        </div>
        <div class="li">
          <span class="tt">水表欠费金额</span>
          <span class="num">¥10000.00</span>
          <div class="text">欠费表数: 8/40</div>
          <img src="@/assets/imgs/c5.png">
        </div>

      </div>
    </div>
    <div class="center">
      <span class="piced">
        <span class="active">电表</span>
        <span>水表</span>
      </span>
      <el-tabs v-model="activeName" @tab-click="getListData">
        <el-tab-pane label="本月充值账单" name="month">
          <div class="search-input-btn" style="width:100%;margin: 0;margin-bottom: 12px;">
            <div class="input-small">
              <span>筛选：</span>
              <el-input v-model="searched" size="mini" placeholder="请输入能耗类型、区域、设备" clearable></el-input>
            </div>
            <!-- <el-button type="primary" size="mini" style="margin-left: 12px;">查询</el-button> -->
            <el-button type="primary" size="mini" @click="exportList" style="margin-left: 12px;">下载</el-button>
          </div>
          <span id="aaa">
            <el-table height="62vh" stripe :data="tableData" style="width: 100%" row-key="id">
              <template slot="empty">
                <span class="noData">
                  <img src="@/assets/noData.png" alt="暂无数据">
                  <span class="text">暂无数据</span>
                </span>
              </template>
              <el-table-column type="index" label="序号" width="60" align="center">
              </el-table-column>
              <el-table-column label="设备名" align="left" prop="a" />
              <el-table-column label="业主" align="left" prop="b" />
              <el-table-column label="充值方式" align="left" prop="c" />
              <el-table-column label="充值时间" align="left" prop="d" />
              <el-table-column label="充值金额" align="left" prop="e" />
              <el-table-column label="结算状态" align="left" prop="f" />
              <el-table-column label="操作" align="center" width="210">
                <template #default="{row}">
                  <el-button type="text" @click="details(row)">详情</el-button>

                </template>
              </el-table-column>
            </el-table>
          </span>
        </el-tab-pane>

        <el-tab-pane label="本月欠费账单" name="year">
          <div class="search-input-btn" style="width:100%;margin: 0;margin-bottom: 12px;">
            <div class="input-small">
              <span>筛选：</span>
              <el-input v-model="searched" size="mini" placeholder="请输入能耗类型、区域、设备" clearable></el-input>
            </div>
            <el-button type="primary" size="mini" @click="exportList" style="margin-left: 12px;">下载</el-button>
          </div>
          <div id="bbb">
            <!--  -->
            <el-table id="demo2" height="62vh" stripe :data="tableData" style="width: 100%" row-key="id">
              <template slot="empty">
                <span class="noData">
                  <img src="@/assets/noData.png" alt="暂无数据">
                  <span class="text">暂无数据</span>
                </span>
              </template>
              <el-table-column type="index" label="序号" width="60" align="center">
              </el-table-column>
              <el-table-column label="设备名" align="left" prop="a" />
              <el-table-column label="业主" align="left" prop="b" />
              <el-table-column label="充值方式" align="left" prop="c" />
              <el-table-column label="充值时间" align="left" prop="d" />
              <el-table-column label="充值金额" align="left" prop="e" />
              <el-table-column label="结算状态" align="left" prop="f" />
              <el-table-column label="操作" align="center" width="210">
                <template #default="{row}">
                  <el-button type="text" @click="details(row)">详情</el-button>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </el-tab-pane>
      </el-tabs>
    </div>


    <el-drawer :title="drawerTitle" :visible.sync="drawerStatus" direction="rtl" custom-class="drawered">
      <span class="dra_box">
        <el-table id="demo" stripe :data="detailData" border style="width: 900px">
          <template slot="empty">
            <span class="noData">
              <img src="@/assets/noData.png" alt="暂无数据">
              <span class="text">暂无数据</span>
            </span>
          </template>
          <el-table-column prop="name" label="日期" width="120" align="center">
          </el-table-column>
          <el-table-column :label="e" v-for="(e,i) in dayOption.xAxis.data" :key="i" :prop="'i'+i" align="center">

          </el-table-column>

        </el-table>
        <div class="chart">
          <vchart style="height: 500px;width: 100%;" ref='vchart1'></vchart>
        </div>
      </span>
    </el-drawer>
    <downloadTable ref="downloadTable"></downloadTable>

  </div>
</template>
<script>
  import request from "@/api/http.js";
  import downloadTable from '@/components/module/downloadTable/downloadTable.vue'
  import vchart from '@/components/module/Charts/chart.vue';//echart图
  export default {
    components: { downloadTable, vchart },
    data() {
      return {
        pickerOptions: {
          disabledDate(time) {
            return time.getTime() > Date.now();
          },
        },
        searched: '',//筛选条件
        detailData: [],//详情数据
        list: [
          {
            "消耗": "10",
            "同比": "10",
            "环比": "10.0"
          },
          {
            "消耗": "20",
            "同比": "20.0",
            "环比": "20.0"
          },
          {
            "消耗": "30",
            "同比": "30.0",
            "环比": "30.0"
          },
          {
            "消耗": "20",
            "同比": "20.1",
            "环比": "20.0"
          }
        ],
        drawerTitle: '',//抽屉标题
        drawerStatus: false,//详情抽屉
        value2: new Date(),//日期
        value: '',
        activeName: 'month',//日期格式
        tableData: [
          {
            a: 'A101电表#1',
            b: '张华华',
            c: '微信',
            d: '2024/10/10 12:00:00',
            e: '¥200.00',
            f: '已结清',
          },
          {
            a: 'A101电表#1',
            b: '张华华',
            c: '微信',
            d: '2024/10/10 12:00:00',
            e: '¥200.00',
            f: '已结清',
          },
          {
            a: 'A101电表#1',
            b: '张华华',
            c: '微信',
            d: '2024/10/10 12:00:00',
            e: '¥200.00',
            f: '已结清',
          },
          {
            a: 'A101电表#1',
            b: '张华华',
            c: '微信',
            d: '2024/10/10 12:00:00',
            e: '¥200.00',
            f: '已结清',
          },
          {
            a: 'A101电表#1',
            b: '张华华',
            c: '微信',
            d: '2024/10/10 12:00:00',
            e: '¥200.00',
            f: '已结清',
          },
          {
            a: 'A101电表#1',
            b: '张华华',
            c: '微信',
            d: '2024/10/10 12:00:00',
            e: '¥200.00',
            f: '已结清',
          },
          {
            a: 'A101电表#1',
            b: '张华华',
            c: '微信',
            d: '2024/10/10 12:00:00',
            e: '¥200.00',
            f: '已结清',
          },
          {
            a: 'A101电表#1',
            b: '张华华',
            c: '微信',
            d: '2024/10/10 12:00:00',
            e: '¥200.00',
            f: '已结清',
          },

        ],
        dayOption: {
          legend: {
            bottom: 0,
            itemWidth: 15,
            icon: "rect",
            textStyle: {
              color: '#000'
            }
          },
          toolbox: {
            show: true,
            showTitle: true, // 隐藏默认文字，否则两者位置会重叠
            right: 50,
            feature: {
              magicType: {
                type: ['line', 'bar'], title: {
                  line: '切换为折线图',
                  bar: '切换为柱状图',
                }
              },
            },

          },
          color: ['#f9987e', "#1e88e5"],
          grid: {
            top: 50,
            right: 56,
            bottom: 69,
          },
          tooltip: {
            trigger: "axis",
            position: function (point, params, dom, rect, size) {
              // 固定在顶部
              return [point[0], '10%'];
            },
            show: true,

            axisPointer: {
              // Use axis to trigger tooltip
              type: "line", // 'shadow' as default; can also be 'line' or 'shadow'
            },
          },
          xAxis: {
            type: 'category',
            splitLine: {
              show: true,
              lineStyle: {
                type: 'dashed', // 设置为虚线
                color: '#ddd' // 虚线颜色
              }
            },
            data: [
              "1月",
              "2月",
              "3月",
              "4月",
              "5月",
              "6月",
              "7月",
              "8月",
              "9月",
              "10月",
              "11月",
              "12月",
            ],
            axisLabel: {
              show: true,
              textStyle: {
                color: '#000'
              }
            }
          },
          yAxis: {
            name: 'kwh/tco2',
            splitLine: {
              show: true,
              lineStyle: {
                type: 'dashed', // 设置为虚线
                color: '#ddd' // 虚线颜色
              }
            },
            show: true, //是否显示
            type: 'value',
            padding: [5, 0, 0, -5],
            max: function (value) {
              return value.max + 1;
            },
            axisLabel: {
              show: true,
              textStyle: {
                color: '#000'
              }
            }
          },
          series: [
            {
              name: '电量',
              data: [0],
              type: 'line',
              smooth: true,
              showSymbol: false,
            },
            {
              name: '碳排',
              data: [0],
              type: 'line',
              smooth: true,
              showSymbol: false,

            }
          ]
        },
      };
    },

    mounted() {

    },
    watch: {
      nowUnit() {
        this.getList();//统一id获取数据
      }
    },
    computed: {
      nowUnit() {
        return this.$store.unitStore.state.nowUnit;
      }
    },
    methods: {
      details(v) {
        console.log(v);
        //  activeName: 'month',//日期格式
        if (this.activeName == 'month') {
          const now = this.value2;
          const year = now.getFullYear();
          const month = now.getMonth() + 1; // 月份从0开始，所以要加1
          const days = new Date(year, month, 0).getDate();
          console.log(days, 'days')
          var d = [];
          for (let i = 0; i < days; i++) {
            d.push((i + 1) + '日')

          }

          this.dayOption.xAxis.data = d;

          this.drawerTitle = v.deviceType + month + '月报表详情';
        } else {
          this.dayOption.xAxis.data = ["1月", "2月", "3月", "4月", "5月", "6月", "7月", "8月", "9月", "10月", "11月", "12月"];
          this.drawerTitle = v.deviceType + this.value2.getFullYear() + '年报表详情';
        };
        this.drawerStatus = true;

        var datad = {
          id: v.id,
          type: this.activeName,
        };
        var data = this.getFormData(datad);
        request({ url: "/carbonEission/getDetail", method: "post", data }).then(
          (res) => {
            if (res.code == 200) {
              // this.detailData = res.data;
              var a = '电量(kwh)';
              if (v.energyType == '水') {
                a = '水量(吨)'
              }
              if (v.energyType == '气') {
                a = '气量'
              }
              if (v.energyType == '汽') {
                a = '汽量'
              }

              var bb = [
                {
                  name: a,
                },
                {
                  name: '碳排放(tco2)',
                },
              ];
              if (res.data['能耗']) {
                res.data['能耗'].map((v, i) => {
                  bb[0]['i' + i] = v;
                })
                res.data['碳排放'].map((v, i) => {
                  bb[1]['i' + i] = v;
                });
              } else {
                bb = []
              }

              this.detailData = bb;//详情列表

              this.dayOption.series[0].name = v.energyType + '量';
              this.dayOption.series[0].data = res.data['能耗'];
              this.dayOption.series[1].data = res.data['碳排放'];
              this.$refs.vchart1.setData(this.dayOption, true);
            }
          });

        setTimeout(() => {
          this.$refs.vchart1.setData(this.dayOption, true);
        }, 500);
      },
      // 下载excel
      exportList(v) {
        let time = new Date();
        let year = time.getFullYear();
        let month = time.getMonth() + 1;
        let day = time.getDate();
        const tHeader = [];
        // activeName: 'month',//日期格式
        if (this.activeName == 'month') {
          this.$refs.downloadTable.export2Excel(tHeader, this.tableData, year + "-" + month + "-" + day + '-月报表', '#aaa')
        } else {
          this.$refs.downloadTable.export2Excel(tHeader, this.tableData, year + "-" + month + "-" + day + '-年报表', '#bbb')
        }

      },

      handleClick(v) {
        console.log(v.name)
      },
      getTimed() {
        if (this.activeName == 'month') {
          const firstDayOfMonth = new Date(this.value2.getFullYear(), this.value2.getMonth(), 1);
          return firstDayOfMonth.getTime();
        } else {
          const firstDayOfMonth = new Date(this.value2.getFullYear(), 0, 1);
          return firstDayOfMonth.getTime();
        }

      },
      // 获取列表数据
      getListData() {
        this.searched = '';
        var datad = {
          beginTime: this.getTimed(),
          type: this.activeName,
          unitId: this.nowUnit.id
        }
        var data = this.getFormData(datad);
        request({ url: "/carbonEission/findArea", method: "post", data }).then(
          (res) => {
            if (res.code == 200) {
              this.tableData = res.data;
            }
          });
      },
      // 获取数据
      getList() {
        this.getListData();//获取列表数据
        var data = this.getFormData({ unitId: this.nowUnit.id });
        // 碳排放相关->获取耗能和碳排的数量，同比和环比
        request({ url: "/carbonEission/getData", method: "post", data }).then(
          (res) => {
            if (res.code == 200) {
              this.list = res.data;
            }
          });
      },
      getFormData(v) {
        let formData = new FormData();
        for (const key in v) {
          formData.append(key, v[key]);
        }
        return formData;

      },

    },


  };
</script>

<style scoped lang="scss">
  .dra_box {
    display: block;
    padding: 0 20px;

    .chart {
      margin-top: 20px;
    }
  }

  .ul_box {
    height: 170px;
    background: #fff;
    box-sizing: border-box;
    padding: 20px;

    .ul_tit {
      font-family: Microsoft YaHei;
      font-size: 16px;
      margin-bottom: 12px;
      font-variation-settings: "opsz" auto;
      color: #1A1A1A;
    }
  }

  .ul {
    display: flex;

    .li:nth-child(1) {
      margin-left: 0;
    }

    .li {
      position: relative;
      height: 97px;
      border-radius: 4px;
      opacity: 1;
      padding: 12px;
      background: #FAFAFA;
      box-sizing: border-box;
      border: 1px solid #EBEBEB;
      margin-left: 12px;
      width: calc(20% - 9px);
      display: flex;
      flex-direction: column;
      justify-content: center;

      img {
        position: absolute;
        right: 12px;
        top: 18px;
        width: 36px;
        height: 36px;
      }

      .tt {
        font-family: Microsoft YaHei;
        font-size: 14px;
        color: #4D4D4D;
        margin-bottom: 8px;
      }

      .num {
        font-family: Arial;
        font-size: 20px;
        font-weight: bold;
        margin-bottom: 7px;
        color: #1A1A1A;
      }

      .text {
        font-family: Microsoft YaHei;
        font-size: 12px;
        color: #4D4D4D;
      }

    }
  }

  .center {
    background-color: #fff;
    margin-top: 8px;
    padding: 12px 20px;
    height: 73vh;
    position: relative;


    .piced {
      position: absolute;
      top: 10px;
      right: 20px;
      z-index: 9;
      width: 104px;
      height: 28px;
      border-radius: 4px;
      opacity: 1;
      /* 自动布局 */
      display: flex;
      box-sizing: border-box;
      justify-content: space-around;
      align-items: center;
      padding: 2px;
      background: #F6F6F6;
      border: 1px solid #E5E5E5;
      color: #666;

      span {
        width: 50px;
        height: 24px;
        border-radius: 4px;
        text-align: center;
        line-height: 24px;
      }

      .active {
        background: #fff;
        color: #000;

      }
    }
  }
</style>
<style lang="scss">
  .mydayreport .drawered {
    width: auto !important;
  }
</style>